/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'

const http ={
    /**
     * methods: 请求
     * @param url 请求地址 
     * @param params 请求参数
     * @param type 请求判断区分 转为formdata数据格式
     */
    get(url,params,type,headers){
        const config = {
            method: 'get',
            url:url
        }
        if(params) config.params = params
        if(type) config.type = type
         // 针对导出文件流
         if(type === "export"){
          config.responseType='blob',
          config.headers = {
            'Content-Type': 'application/json'
          }
        }
        // 自定义请求头(如 Authorization)合并到 config.headers
        if(headers) config.headers = { ...(config.headers || {}), ...headers }
        return request(config)
    },
    post(url,params,type,headers){
        const config = {
            method: 'post',
            url:url
        }
        if(params) config.data = params
        if(type === 1) {
          config.type = type
        }
        // 针对导出文件流
        if(type === "export"){
          config.responseType='blob',
          config.headers = {
            'Content-Type': 'application/json'
          }
        }
        // 自定义请求头(如 Authorization)合并到 config.headers
        if(headers) config.headers = { ...(config.headers || {}), ...headers }
        return request(config)
    },
    put(url,params,type){
        const config = {
            method: 'put',
            url:url
        }
        if(params) config.data = params
        if(type) config.type = type
        return request(config)
    },
    delete(url,params,type){
        const config = {
            method: 'delete',
            url:url
        }
        if(params) config.params = params
        if(type) config.type = type
        return request(config)
    }
}
//导出
export default http



// WEBPACK FOOTER //
// ./src/utils/http.js